import React from 'react';

const Ex2_Intro = () => {
    return (
        <div>Ex2_Intro Component</div>
    );
}

export default Ex2_Intro;
